<template>
    <div>
        <div class="container dcs-container">
            <div class="row">
                <div class="col-md-10 col-md-offset-1">
                    <div class="dcs-frame">
                        <div class="dcs-message-1">
                            <p>Your signup request was successfully received, but is taking
                                <span class="dcs-emph">longer than typical</span> to process.</p>
                            <p>Once complete, you will receive a welcome email from DesignDocs with instructions for getting started.</p>
                            <p>If you choose to wait on this page, you should see the Registration status switch to Completed.</p>
                        </div>
                        <div class="dcs-status-zone">
                            <table class="table">
                                <tr>
                                    <td class="dcs-tabcol-1"> Submission </td>
                                    <td>
                                        <span class="glyphicon glyphicon-ok dcs-status-good" />
                                        <span class="dcs-status-msg dcs-status-good">OK</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="dcs-tabcol-1"> Registration </td>
                                    <td>
                                        <span class="glyphicon" v-bind:class="statusGlyphStyle()"/>
                                        <span class="dcs-status-msg" v-bind:class="statusMsgStyle()">{{regStatusDesc}}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="dcs-link-block">
                            <a href="http://www.designdocs.com">Back to DesignDocs</a><span style="margin-left:90px;"/>
                            <a href="mailto:support@designdocs.com">Contact Support</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <button @click="doTestComplete" >Foo</button> -->
    </div>
</template>

<script>
    export default {
        name: "timeoutpage",
        data() {
            return {};
        },
        methods: {
            statusGlyphStyle() {
                let result = [];
                if (this.complete) {
                    result.push('glyphicon-ok');
                    result.push('dcs-status-good');
                } else {
                    result.push('glyphicon-asterisk');
                    result.push('dcs-status-busy');
                }
                return result;
            },
            statusMsgStyle() {
                let result = [];
                if (this.complete) {
                    result.push('dcs-status-good');
                } else {
                    result.push('dcs-status-busy');
                }
                return result;
            },
            doTestComplete() {
                let curStatus = this.$store.state.timeoutPageData.complete;
                this.$store.commit('SET_TIMEOUT_COMPLETE', (!curStatus));
            }
        },
        computed: {
            complete() {
                return this.$store.state.timeoutPageData.complete;
            },
            regStatusDesc() {
                if (this.complete) {
                    return 'Completed';
                }
                return 'Still in Progress';
            }
        }
    };
</script>

<style>
    .dcs-container {
      margin-top: 140px;
    }
    .dcs-frame {
      height: 360px;
      background-color: rgba(255, 255, 255, 0.8);
      border-radius: 20px;
      border: 1px solid grey;
      position: relative;
    }
    .dcs-message-1 {
      width: 340px;
      text-align: left;
      margin: 20px 0 0 20px;
      font-size: large;
      float: left;
    }
    .dcs-status-zone {
      text-align: left;
      margin: 80px 0 0 60px;
      font-size: large;
      float: left;
    }
    .dcs-tabcol-1 {
      padding-right: 30px;
    }
    .dcs-status-msg {
      margin-left: 8px;
    }
    .dcs-status-good {
      color: green;
    }
    .dcs-status-busy {
      color: rgb(77, 122, 158);
    }
    .dcs-emph {
      font-style: italic;
      font-weight: bold;
    }
    .dcs-link-block {
      position: absolute;
      bottom: 20px;
      text-align: center;
      width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/TimeoutPage.vue